<template>
  <div class="row justify-content-md-center mb-3">
    <!-- <div class="col-12 col-md-6 mr-auto mx-auto mb-3 text-center p-2">
        <HoraLogo></HoraLogo>
      </div> -->
    <HoraStats :stat_type="'all_charts'"></HoraStats>

    <div class="w-100"></div>
    <div
      class="col-12 col-md-11 col-xl-6 mr-auto mx-auto mb-3 chart-form p-2"
      style="box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16)"
    >
      <div class="row" style="direction: rtl">
        <div class="col-12 col-md-4 order-2 mt-3 m-md-0">
          <select v-model="chart_request.gender" name="gender" id="gender" class="block w-full text-slate-500 placeholder:text-slate-500 rounded-lg bg-slate-100 py-2 px-3 border border-slate-200 mb-5">
            <option value="null" disabled>جنسیت</option>
            <option value="0">زن</option>
            <option value="1">مرد</option>
            <option value="2">non-binary/other</option>
          </select>

          <div
            :style="`
              text-align: center;
              border-radius: 8px;
              display: ${errors.gender_error};
              line-height: 40px;
              border: 1px solid rgba(255, 0, 51, 0.3);
              font-size: 14px;
              margin-top: 8px;
              color: red;
              text-shadow: rgb(255, 255, 255) 1px 1px;`"
          >
            جنسیت خود را انتخاب کنید
          </div>
        </div>
        <div class="col-12 col-md-8 order-1 m-md-0 mt-3">
          <input
            type="text"
            v-model="chart_request.title"
            class="form-control chart-input chart-title"
            placeholder="نام"
          />
          <div
            :style="`
                text-align: center;
                display: ${errors.name_error};
                border-radius: 8px;
                line-height: 40px;
                border: 1px solid rgba(255, 0, 51, 0.3);
                font-size: 14px;
                margin-top: 8px;
                color: red;
                text-shadow: rgb(255, 255, 255) 1px 1px;`"
          >
            این فیلد الزامی است. نام حداقل باید از ۲ حرف باشد.
          </div>
        </div>
      </div>
      <div class="w-100 m-3"></div>
      <div class="row justify-content-center" style="direction: ltr">
        <div class="col-12 col-md-8 m-md-0 mb-3 order-1">
          <DatePicker
            :limit_future_range="false"
            :limit_under_18y="false"
            @updateValidaDateVar="updateValidDate"
            @updateDatePickerForm="updateFormDate"
          ></DatePicker>
          <div
            class="input-group p-2"
            :style="`
            text-align: center;
            border-radius: 8px;;
            border: 1px solid rgba(255, 0, 51, 0.3);
            display: ${errors.date_error};
            direction: rtl;
            font-size: 14px;
            margin-top: 8px;
            color: red;
            text-shadow: rgb(255, 255, 255) 1px 1px;`"
          >
            تاریخ نامعتبر است.
          </div>
        </div>
        <div class="col-12 col-md-4 m-0 order-2">
          <TimePicker @updateTimePickerForm="updateFormTime"></TimePicker>
          <div
            class="input-group p-2"
            :style="`
            text-align: center;
            border-radius: 8px;;
            border: 1px solid rgba(255, 0, 51, 0.3);
            display: ${errors.time_error};
            direction: rtl;
            font-size: 14px;
            margin-top: 8px;
            color: red;
            text-shadow: rgb(255, 255, 255) 1px 1px;`"
          >
            زمان نامعتبر است.
          </div>
        </div>
      </div>

      <div class="w-100 m-3"></div>
      <autocomplete
        :style="`font-size: 16px; text-align: center; border: ${errors.location_error} 1px solid; border-radius: 8px;`"
        aria-label="جستجوی موقعیت جغرافیایی"
        placeholder="شهر محل تولد"
        :search="search"
        :get-result-value="getResultValue"
        @submit="handleSubmit"
      >
      </autocomplete>

      <div class="w-100 m-3"></div>
      <div class="row justify-content-center" style="direction: ltr">
        <div class="col-12 col-md-4 m-md-0 mb-3 order-1">
          <div class="container mt-2">
            <div
              class="form-check form-switch"
              style="font-size: 14px; text-align: center"
            >
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="is_advance_form"
                id="flexSwitchCheckDefaultDet"
              />
              <label class="form-check-label" for="flexSwitchCheckDefaultDet"
                >تنظیمات بیشتر</label
              >
            </div>
          </div>
        </div>
      </div>

      <div class="advanced-area" style="direction: ltr" v-if="is_advance_form">
        <div
          class="mr-auto mx-auto mt-2 mb-2"
          style="border-top: 1px dashed #ccc; width: 80%"
        ></div>
        <div class="row justify-content-center p-2">
          <div class="col-12 col-md-6 m-md-0 mb-3">
            <DSTSelector @updateFormDSToffset="updateDSToffset"></DSTSelector>
          </div>

          <div class="col-12 col-md-6 m-md-0 mb-3">
            <TimezoneSelector
              :input_disabled="true"
              :default_input="chart_request.timezone"
            ></TimezoneSelector>
          </div>
          <div class="row justify-content-center">
            <div class="col-12 col-md-4 mt-3">
              <div
                class="form-check form-switch"
                style="font-size: 14px; text-align: center"
              >
                <input
                  v-model="show_analysis"
                  @click="showAnalysis()"
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="showAnalyisCheck"
                />
                <label class="form-check-label" for="showAnalyisCheck"
                  >نمایش تفسیر پایه</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-100 m-3"></div>
      <div class="container text-center mb-2">
        <div class="mb-3 text-center" style="direction: ltr;">
          <button type="button" class="btn btn-primary" @click="submitChart()">
            محاسبه چارت تولد
          </button>
        </div>
      </div>
    </div>
    <Loading :is-loading="isLoading" />
  </div>
</template>

<script>
import DatePicker from "./DatePicker.vue";
import TimePicker from "./TimePicker.vue";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import HoraLogo from "./HoraLogo.vue";
import ApiService from "../service/api";
import DSTSelector from "./DSTSelector.vue";
import TimezoneSelector from "./TimezoneSelector.vue";
import HoraStats from "./HoraStats.vue";
import HelperLib from "./helper";
import Loading from "./Loading.vue";

export default {
  name: "ChartFormBasic",
  components: {
    Loading,
    DatePicker,
    Autocomplete,
    HoraLogo,
    DSTSelector,
    TimezoneSelector,
    TimePicker,
    HoraStats,
  },
  data() {
    return {
      isLoading: false,
      valid_date: true,
      errors: {
        name_error: "none",
        gender_error: "none",
        time_error: "none",
        date_error: "none",
        location_error: "transparent",
      },
      show_analysis: true,
      is_advance_form: false,
      selected_tz: "",
      chart_request: {
        title: "",
        gender: null,
        latitude: null,
        longitude: null,
        altitude: null,
        year: null,
        month: null,
        day: null,
        hour: null,
        min: null,
        sec: null,
        timezone: null,
        city: null,
        state: null,
        country: null,
        tz_country: null,
        date_type: null,
        dasha_date_type: null,
        vargas: null,
        nesting: null,
        t_year: null,
        t_month: null,
        t_day: null,
        t_hour: null,
        t_min: null,
        t_sec: null,
        t_date_type: null,
        dst_min: "0",
        dst_hour: "0",
        lat_deg: null,
        lat_min: null,
        lat_dir: null,
        lon_deg: null,
        lon_min: null,
        lon_dir: null,
        display_loc: "",
      },
      chart_result: Object,
    };
  },
  methods: {
    updateValidDate(value) {
      this.valid_date = value;
    },
    updateFormDate(year, month, day, date_type) {
      this.chart_request.year = year;
      this.chart_request.month = month;
      this.chart_request.day = day;
      this.chart_request.date_type = date_type;
    },
    updateFormTime(hour, min, sec) {
      this.chart_request.hour = hour;
      this.chart_request.min = min;
      this.chart_request.sec = sec;
    },
    updateFormTimezone(tz) {
      this.chart_request.timezone = tz;
    },
    updateDSToffset(dst_value) {
      if (dst_value == 0) {
        this.chart_request.dst_hour = "0";
        this.chart_request.dst_min = "0";
      }
      if (dst_value == 1) {
        this.chart_request.dst_hour = "0";
        this.chart_request.dst_min = "30";
      }
      if (dst_value == 2) {
        this.chart_request.dst_hour = "1";
        this.chart_request.dst_min = "0";
      }
      if (dst_value == 3) {
        this.chart_request.dst_hour = "1";
        this.chart_request.dst_min = "30";
      }
      if (dst_value == 4) {
        this.chart_request.dst_hour = "2";
        this.chart_request.dst_min = "0";
      }
    },
    openAdvanceForm() {
      if (this.is_advance_form) this.is_advance_form = false;
      else this.is_advance_form = true;
    },
    validateForm() {
      let result = false;
      if (this.valid_date) {
        this.errors.date_error = "block";
      }
      if (!this.valid_date) {
        this.errors.date_error = "none";
      }
      if (
        this.chart_request.title === "" ||
        String(this.chart_request.title).length < 3
      ) {
        this.errors.name_error = "block";
      }
      if (this.chart_request.title != "" && String(this.chart_request.title).length > 1) {
        this.errors.name_error = "none";
      }
      if (this.chart_request.gender === null) {
        this.errors.gender_error = "block";
      }
      if (this.chart_request.gender != null) {
        this.errors.gender_error = "none";
      }
      if (this.chart_request.hour === null || this.chart_request.min === null) {
        this.errors.time_error = "block";
      }
      if (this.chart_request.year === null) {
        this.errors.date_error = "block";
      }
      if (this.chart_request.longitude == null) {
        this.errors.location_error = "red";
      }
      if (this.chart_request.hour != null && this.chart_request.min != null) {
        this.errors.time_error = "none";
      }
      if (this.chart_request.year != null) {
        this.errors.date_error = "none";
      }
      if (this.chart_request.longitude != null) {
        this.errors.location_error = "transparent";
      }
      if (
        this.chart_request.year != null &&
        this.chart_request.month != null &&
        this.chart_request.day != null &&
        this.chart_request.hour != null &&
        this.chart_request.min != null &&
        this.chart_request.longitude != null &&
        this.chart_request.title != "" &&
        String(this.chart_request.title).length > 1 &&
        this.chart_request.gender != null &&
        this.valid_date == true
      ) {
        result = true;
      }
      return result;
    },
    resetFormErrors() {},
    showFormErrors() {},
    submitChart() {

      if (this.validateForm()) {
        this.isLoading = true;
        ApiService.getFreeChart(this.chart_request).then((response) => {
          this.chart_result = response["data"];
          let share_box = document.getElementById("share-box");
          if (share_box) {
            share_box.style.display = "block";
          }
          this.isLoading = false;
          this.$emit("getRequestData", this.chart_request);
          this.$emit("appViewUpdateData", this.chart_result);
        });
      }
    },
    test_submitChart() {
      let request = {
        title: "test",
        gender: "0",
        latitude: -6.0300079,
        longitude: 143.4023685,
        altitude: null,
        year: 1340,
        month: 1,
        day: 10,
        hour: 5,
        min: 30,
        sec: 0,
        timezone: "+03:00",
        city: "Mapia Teh",
        state: "Southern Highlands Province",
        country: "Papua New Guinea",
        tz_country: "PG",
        date_type: "jalali",
        dasha_date_type: null,
        vargas: null,
        nesting: null,
        t_year: null,
        t_month: null,
        t_day: null,
        t_hour: null,
        t_min: null,
        t_sec: null,
        t_date_type: null,
        dst_min: "0",
        dst_hour: "0",
        lat_deg: null,
        lat_min: null,
        lat_dir: null,
        lon_deg: null,
        lon_min: null,
        lon_dir: null,
      };

      this.isLoading = true;
      ApiService.getFreeChart(request).then((response) => {
        this.chart_result = response["data"];
        let share_box = document.getElementById("share-box");
        if (share_box) {
          share_box.style.display = "block";
        }
        this.isLoading = false;
        this.$emit("appViewUpdateData", this.chart_result);

        HelperLib.hideLoading();
      });
    },
    showAnalysis() {
      this.show_analysis = !this.show_analysis;
      this.$emit("updateShowAnalysis", this.show_analysis);
    },
    search(input) {
      return new Promise((resolve) => {
        // let url = `https://photon.komoot.io/api/?q=${encodeURI(input)}&layer=city`;
        let url = `https://nominatim.openstreetmap.org/search?format=geojson&limit=5&addressdetails=1&city=${encodeURI(
          input
        )}`;
        if (input.length < 2) {
          return resolve([]);
        }
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            resolve(data.features);
          });
      });
    },
    getResultValue(result) {
      let _c = result["properties"]["address"]["country"]
        ? result["properties"]["address"]["country"]
        : "بدون کشور";
      let _m = result["properties"]["address"]["state"]
        ? result["properties"]["address"]["state"]
        : result["properties"]["address"]["province"]
        ? result["properties"]["address"]["province"]
        : result["properties"]["address"]["region"]
        ? result["properties"]["address"]["region"]
        : "";
      let _ci = result["properties"]["address"]["city"]
        ? result["properties"]["address"]["city"]
        : result["properties"]["address"]["village"]
        ? result["properties"]["address"]["village"]
        : result["properties"]["address"]["hamlet"]
        ? result["properties"]["address"]["hamlet"]
        : "";
      let _vi = result["properties"]["address"]["town"]
        ? result["properties"]["address"]["town"]
        : "";
      return result["properties"]["name"] + " - " + _m + " - " + _c;

      // return _c + " , " + _m + " , " + _ci + _vi;
    },
    handleSubmit(result) {
      this.chart_request.longitude = result["geometry"]["coordinates"][0];
      this.chart_request.latitude = result["geometry"]["coordinates"][1];
      this.chart_request.tz_country = result["properties"]["address"]["country_code"];
      this.chart_request.city = result["properties"]["address"]["city"]
        ? result["properties"]["address"]["city"]
        : result["properties"]["address"]["village"]
        ? result["properties"]["address"]["village"]
        : result["properties"]["address"]["hamlet"];
      this.chart_request.state = result["properties"]["address"]["state"]
        ? result["properties"]["address"]["state"]
        : result["properties"]["address"]["province"]
        ? result["properties"]["address"]["province"]
        : result["properties"]["address"]["region"]
        ? result["properties"]["address"]["region"]
        : result["properties"]["address"]["district"];
      this.chart_request.country = result["properties"]["address"]["country"];
      this.chart_request.display_loc = result["properties"]["display_name"];
      this.handlerNearestTimezone();
    },
    handlerNearestTimezone() {
      let request = {
        latitude: this.chart_request.latitude,
        longitude: this.chart_request.longitude,
        tz_country: this.chart_request.tz_country,
      };


      if (this.chart_request.tz_country == 'ir'){
        this.chart_request.timezone = "+03:30";
      } else {
        HelperLib.showLoading();
        this.isLoading = true;
        ApiService.getNearestTimezone(request).then((response) => {
          this.chart_request.timezone = response["data"][1];
          this.isLoading = false;
          // console.log(response);
          HelperLib.hideLoading();
        });
      }
    },
  },
};
</script>





<style scoped>
.chart-input {
  border: 1px solid #eee;
  border-radius: 8px;
  width: 100%;
  padding: 12px 48px 12px 12px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  line-height: 1.5;
  flex: 1;
  text-align: center;
  background-color: #eee;
  background-repeat: no-repeat;
  background-position: right;
  margin: 0;
}
.chart-input:focus,
.chart-input[aria-expanded="true"] {
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #fff;
  outline: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.chart-datepicker > input {
  background: #eee;
}

.chart-title {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktaW5wdXQtY3Vyc29yLXRleHQiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNSAyYS41LjUgMCAwIDEgLjUtLjVjLjg2MiAwIDEuNTczLjI4NyAyLjA2LjU2Ni4xNzQuMDk5LjMyMS4xOTguNDQuMjg2LjExOS0uMDg4LjI2Ni0uMTg3LjQ0LS4yODZBNC4xNjUgNC4xNjUgMCAwIDEgMTAuNSAxLjVhLjUuNSAwIDAgMSAwIDFjLS42MzggMC0xLjE3Ny4yMTMtMS41NjQuNDM0YTMuNDkgMy40OSAwIDAgMC0uNDM2LjI5NFY3LjVIOWEuNS41IDAgMCAxIDAgMWgtLjV2NC4yNzJjLjEuMDguMjQ4LjE4Ny40MzYuMjk0LjM4Ny4yMjEuOTI2LjQzNCAxLjU2NC40MzRhLjUuNSAwIDAgMSAwIDEgNC4xNjUgNC4xNjUgMCAwIDEtMi4wNi0uNTY2QTQuNTYxIDQuNTYxIDAgMCAxIDggMTMuNjVhNC41NjEgNC41NjEgMCAwIDEtLjQ0LjI4NSA0LjE2NSA0LjE2NSAwIDAgMS0yLjA2LjU2Ni41LjUgMCAwIDEgMC0xYy42MzggMCAxLjE3Ny0uMjEzIDEuNTY0LS40MzQuMTg4LS4xMDcuMzM1LS4yMTQuNDM2LS4yOTRWOC41SDdhLjUuNSAwIDAgMSAwLTFoLjVWMy4yMjhhMy40OSAzLjQ5IDAgMCAwLS40MzYtLjI5NEEzLjE2NiAzLjE2NiAwIDAgMCA1LjUgMi41LjUuNSAwIDAgMSA1IDJ6Ii8+CiAgPHBhdGggZD0iTTEwIDVoNGExIDEgMCAwIDEgMSAxdjRhMSAxIDAgMCAxLTEgMWgtNHYxaDRhMiAyIDAgMCAwIDItMlY2YTIgMiAwIDAgMC0yLTJoLTR2MXpNNiA1VjRIMmEyIDIgMCAwIDAtMiAydjRhMiAyIDAgMCAwIDIgMmg0di0xSDJhMSAxIDAgMCAxLTEtMVY2YTEgMSAwIDAgMSAxLTFoNHoiLz4KPC9zdmc+);
  background-position: calc(100% - 10px);
  text-align: center;
  background-size: 20px;
  height: 55px;
}

.chart-form {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
}


</style>
